import { registerComponent } from '@gig/magic-common';
import TabsComponent from './tabs.vue.js';

var Tabs = registerComponent(TabsComponent);

export { Tabs };
